import { render, staticRenderFns } from "./DragTheWordsPreview.vue?vue&type=template&id=528a5eb6&scoped=true&"
import script from "./DragTheWordsPreview.vue?vue&type=script&lang=js&"
export * from "./DragTheWordsPreview.vue?vue&type=script&lang=js&"
import style0 from "./DragTheWordsPreview.vue?vue&type=style&index=0&id=528a5eb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a5eb6",
  null
  
)

component.options.__file = "DragTheWordsPreview.vue"
export default component.exports